import Vue from "vue";
import Vuex from "vuex";
import { RootState } from "./types";
import { login } from "./login/index";
import { rapport } from "./rapports/index";
import { config } from "./config/index";
import { home } from "./home/index";
import { analyses } from "./analyses/index";
import { bdd } from "./bdd/index";
import { icones } from "./icones/index";
import axios from "@/plugins/axios";

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    version: "1.3.0",
    serverVersion: "0",
    isGlobal: true,
    isTotal: false,
    client: "",
    isApp: false,
  },
  modules: {
    login,
    rapport,
    config,
    home,
    analyses,
    bdd,
    icones,
  },
  mutations: {},
  actions: {
    async init({ commit, state }) {
      // BK
      /* console.log("init");
      const ip = "https://cassandra3.bkreboot.com:5000/";
      const ip = "https://bk.cashsystemes.com/";
      axios.defaults.baseURL = ip;
      console.log(axios.defaults);
      localStorage.ip = JSON.stringify(ip);
      state.isApp = true;*/
      await axios.get("version").then(
        (data: any) => {
          state.serverVersion = data.data;
          // console.log(data.data)
          state.isGlobal = data.data ? data.data.indexOf("CAS") !== -1 : false;
          state.isTotal = false;
          axios.get("distribution").then((client: any) => {
            state.client = client.data.nom;
            state.client === "TOTAL"
              ? (state.isTotal = false)
              : (state.isTotal = true);
          });
        },
        (error: any) => {
          state.serverVersion = "error";
          state.isGlobal = false;
          state.isTotal = false;
        }
      );
    },
  },
  getters: {
    getGlobal: (state) => state.isGlobal,
    getVersion: (state) => state.serverVersion,
    getTotal: (state) => state.client === "TOTAL",
    getClient: (state) => state.client,
    getApp: (state) => state.isApp,
  },
});
